import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    getDWSMCounterFail,
    getDWSMCounterSuccess,
    getWorkstockCounterFail,
    getWorkstockCounterSuccess,
    getWorkstockSubCountersNavFail,
    getWorkstockSubCountersNavSuccess,
    loadFavoriteCounter
} from './navigation.actions';
import { catchError, map, of, switchMap, timer } from 'rxjs';
import { NavigationService } from '../navigation.service';
import { loadWorkstockComponent, loadWorkstockSubCounters } from '../../workstock/state/workstock.actions';
import { deleteDwsmJobByIdSuccess, getDwsmDashboard } from '../../dwsm/state/dwsm.actions';
import { WorkstockService } from 'src/app/workstock/workstock.service';
import { loadInitializerData } from '../../core/state/core.actions';

const WORKSTOCK_COUNTER_INTERVAL: number = 300000;

const DWSM_COUNTER_INTERVAL: number = 300000;

@Injectable()
export class NavigationEffects {
    constructor(private actions$: Actions, private navigationService: NavigationService, private workstockService: WorkstockService) {}

    getWorkstockCounterTimer$ = createEffect(() => {
        return timer(0, WORKSTOCK_COUNTER_INTERVAL).pipe(
            switchMap(() =>
                this.navigationService.getWorkstockCounter().pipe(
                    map(workstockCounter => getWorkstockCounterSuccess({ workstockCounter })),
                    catchError(() => of(getWorkstockCounterFail()))
                )
            )
        );
    });

    getWorkstockCounter$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(loadWorkstockComponent),
            switchMap(() =>
                this.navigationService.getWorkstockCounter().pipe(
                    map(workstockCounter => getWorkstockCounterSuccess({ workstockCounter })),
                    catchError(() => of(getWorkstockCounterFail()))
                )
            )
        );
    });

    getWorkstockFavoritesCounters$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(loadFavoriteCounter),
            switchMap(() =>
                this.workstockService.getWorkstockSubCounters().pipe(
                    map(workstockSubCounters =>
                        getWorkstockSubCountersNavSuccess({
                            favoriteCounter: workstockSubCounters.favoriteCounter
                        })
                    ),
                    catchError(() => of(getWorkstockSubCountersNavFail()))
                )
            )
        );
    });

    getDWSMCounterTimer$ = createEffect(() => {
        return timer(0, DWSM_COUNTER_INTERVAL).pipe(
            switchMap(() =>
                this.navigationService.getDWSMCounter().pipe(
                    map(dwsmCounter => getDWSMCounterSuccess({ dwsmCounter })),
                    catchError(() => of(getDWSMCounterFail()))
                )
            )
        );
    });

    getDWSMCounter$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(getDwsmDashboard, deleteDwsmJobByIdSuccess),
            switchMap(() =>
                this.navigationService.getDWSMCounter().pipe(
                    map(dwsmCounter => getDWSMCounterSuccess({ dwsmCounter })),
                    catchError(() => of(getDWSMCounterFail()))
                )
            )
        );
    });
}
